import gatewaySettings from '../common/qianniu-gateway-settings';

export default (X) => {

  const gatewayURI = {
    development: '//yungw.daily.taobao.net/gw/invoke/',
    daily      : '//yungw.daily.taobao.net/gw/invoke/',
    pre        : '//yungw.prepub.taobao.com/gw/invoke/',
    production : 'https://qngateway.taobao.com/gw/invoke/',
  };

  let gateway = {

    setup: gatewaySettings.setup,

    invoke(options) {
      let {query} = options;
      query = Object.assign(query || {}, {timestamp: Date.now()});

      // To support api alias, we need to get api info from api map.
      let api = X.getApiByAlias(options.api);

      api =  api || {
        type: X.API_TYPE.QN_GATEWAY,
        uri: options.api,
      };

      options.api = {
        type: X.API_TYPE.AJAX,
        uri: gatewayURI[X.env] + api.uri,
      };
      options.data = options.query || {};
      options.crossOrigin = true;
      options.withCredentials = true;

      return X.call(options);
    }
  };

  return gateway;
};



// WEBPACK FOOTER //
// ./src/plugins/qianniu-gateway-by-ajax.js